import axios from "axios";
import * as ActionType from "./type";
import { Toast } from "../../util/Toast";
export const getVipRewards = (type) => (dispatch) => {
  axios
    .get('vipReward')
    .then((res) => {
      if (res.data.status) {
        console.log("VIP Rewards fetched successfully");
        dispatch({
          type: ActionType.GET_VIP_REWARD,
          payload: res.data.data,
        });
      }
    })
    .catch((error) => console.log("error", error));
};

// Create SVGA
export const createVIPReward = (data) => (dispatch) => {
  axios
    .post(`vipReward`, data)
    .then((res) => {
      if (res.data.status) {

        dispatch({
          type: ActionType.CREATE_VIP_REWARD,
          payload: res.data.data,
        });
        dispatch({ type: ActionType.CLOSE_DIALOGUE_VIP_REWARD });
        Toast("success", "VIP Reward created successfully");
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const updateVipReward = (id, data) => (dispatch) => {
  axios
    .post(`vipReward?id=${id}`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_VIP_REWARD,
          payload: { data: res.data.data, id: id },
        });
        dispatch({ type: ActionType.CLOSE_DIALOGUE_VIP_REWARD });
        Toast("success", "VIP Reward updated successfully");
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const deleteVipReward = (id) => (dispatch) => {
  axios
    .delete(`vipReward/${id}`)
    .then((res) => {
      if (res.data.status) {

        dispatch({ type: ActionType.DELETE_VIP_REWARD, payload: id });
      }
    })
    .catch((error) => console.log("error", error));
};
